<header>
    <div class="header">
        <div routerLink="/home"><img src="../../../assets/white-logo.svg" /></div>

        <p-megamenu [model]="megaMenuItems" />

        <div class="notifications-container">
            <p-button variant="text" icon="pi pi-bell" severity="secondary" />
            <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" 
                size="normal" />
            <p-button variant="text" icon="pi pi-sign-out" severity="secondary" aria-label="Sair" (onClick)="logout()" />
        </div>

    </div>

    <div>
        <p-breadcrumb [model]="items" [home]="home" />
        <p-divider />
    </div>

</header>

<main>
    @if (showPage()) {
        <div animate.enter="page-fade-in" animate.leave="page-fade-out">
            <router-outlet />
        </div>
    }
</main>